import * as React from 'react';

import { Button, Card, Modal, Theme } from '@material-ui/core';
import { makeStyles } from '@material-ui/core/styles';
import { ThemeProvider } from '@material-ui/core/styles';
import { useHistory } from "react-router-dom";
import loginLogo from '../../assets/images/loginLogo.png'
import theme from '../shared/theme';

import LoginPage from '../auth/LoginPage'

interface WelcomeWidgetProps {
};


const useStyles = makeStyles((theme: Theme) => ({
    root: {
        width: 500,
        background: theme.palette.primary.main,
        borderRadius: 0,
    },
    inputs: {
        marginTop: 10,
        marginLeft: 40,
        marginRight: 40,
    },
    button: {
        width: '100%',
        padding: 9,
        borderRadius: 5,
        background: 'white',
        color: theme.palette.primary.main,
        marginBottom: 40,
        fontSize: 'medium'
    },
    link: {
        color: 'whitesmoke',
        marginBottom: 30,
        marginLeft: 40,
        paddingLeft: 0,
        fontSize: 'small'
    },
    logoImg: {
        display: 'block',
        marginTop: 20,
        marginLeft: 'auto',
        width: 374.67,
        marginRight: 'auto',
    },
    logoRoot: {
        height: 140,
    },
    heading: {
        marginBottom: 40,
        color: '#fff',
        marginLeft: 20,
        fontFamily: 'Lato !important',
    }
}));


function WelcomeWidget(props: WelcomeWidgetProps): JSX.Element {
    const classes = useStyles();
    const history = useHistory();
    const getStarted = () => {

        history.push('/login');
    }
    return (
        <React.Fragment>
            <ThemeProvider theme={theme}>
            <Card className={classes.root}>
                <div className={classes.logoRoot}>
                    <img src={loginLogo} className={classes.logoImg} alt="logo" />
                </div>
                <div className={classes.heading}>
                    <h1 className={classes.heading}>Welcome to SMA Live</h1>
                </div>
                <div className={classes.inputs}>
                    <Button
                        onClick={getStarted}
                            /*onClick={}*/
                            className={classes.button}
                        variant="contained">Let's Go</Button>
                </div>
                </Card>
            </ThemeProvider>
        </React.Fragment>
    );
}

export default React.memo(WelcomeWidget) 
